/**
 * ヘッダーナビゲーションのサイズを返すjs
 */

const getHeaderSize = ($target) => {
  const mq = window.matchMedia('(min-width:768px)').matches;
  return (mq) ? $target.outerHeight() : 50;
};
export default getHeaderSize;



// WEBPACK FOOTER //
// ./src/scripts/common/getHeaderSize.js